import React, { useState, useEffect } from 'react';

import { TextField, Button, Grid, Pagination, Paper, Typography, Avatar, IconButton, CircularProgress, FormControl, InputLabel, MenuItem, Select, Link } from '@mui/material';

import MultiSelect from './MultiSelect';
import ItemHeader from './ItemHeader'
import ItemList from './ItemList'

export default function ItemSearch() {
  const [loading, setLoading] = useState(false)
	const [maaraLoading, setMaaraLoading] = useState(false)
	const [tyot, setTyot] = useState([])
	const [tyoMaara, setTyoMaara] = useState(0)
  const [page, setPage] = useState(1)

	const [tyotPerSivu, setTyotPerSivu] = useState(20)
  const [jarjesta, setJarjesta] = useState('vuosi DESC')

	const [tekija, setTekija] = useState("")
	const [otsikko, setOtsikko] = useState("")
	const [saatavuus, setSaatavuus] = useState([])
	const [julkaisuvuosiMin, setJulkaisuvuosiMin] = useState("")
	const [julkaisuvuosiMax, setJulkaisuvuosiMax] = useState("")

	const [kohderyhmatOptions, setKohderyhmatOptions] = useState([])
  const [prosessitOptions, setProsessitOptions] = useState([])
	const [tyypitOptions, setTyypitOptions] = useState([])
  const [tieteenalatOptions, setTieteenalatOptions] = useState([])
	const [teematOptions, setTeematOptions] = useState([])
	const [kieletOptions, setKieletOptions] = useState([])
	const [organisaatiotOptions, setOrganisaatiotOptions] = useState([])
	
	const [kohderyhmat, setKohderyhmat] = useState([])
  const [prosessit, setProsessit] = useState([])
	const [tyypit, setTyypit] = useState([])
  const [tieteenalat, setTieteenalat] = useState([])
	const [teemat, setTeemat] = useState([])
	const [kielet, setKielet] = useState([])
	const [organisaatiot, setOrganisaatiot] = useState([])

	useEffect(() => {
    getOptions()
  }, [])

	useEffect(() => {
    getTyot()
  }, [page])

	useEffect(() => {
    getTyoMaara()
  }, [kohderyhmat, prosessit, tyypit, tieteenalat, teemat, organisaatiot, kielet, otsikko, tekija, saatavuus, julkaisuvuosiMin, julkaisuvuosiMax])


	const getTyot = async () => {
		setLoading(true)
		const filters = {
			tekija,
			otsikko,
			kohderyhmat,
			prosessit,
			tyypit,
			tieteenalat,
			teemat,
			organisaatiot,
			kielet,
			saatavuus,
			julkaisuvuosiMin,
			julkaisuvuosiMax,
			page,
			jarjesta,
			tyotPerSivu
		}

		const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(filters)
		};
		const res = await fetch("/api/tyot", requestOptions);
		
		if (res.ok) {
			const response = await res.json();
			setTyot(response)
			setLoading(false)
		}
	}

	const getTyoMaara = async () => {
		setMaaraLoading(true)
		const filters = {
			tekija,
			otsikko,
			kohderyhmat,
			prosessit,
			tyypit,
			tieteenalat,
			teemat,
			organisaatiot,
			kielet,
			saatavuus,
			julkaisuvuosiMin,
			julkaisuvuosiMax,
			page,
			jarjesta,
			tyotPerSivu
		}

		const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(filters)
		};
		const res = await fetch("/api/tyomaara", requestOptions);
		
		if (res.ok) {
			const response = await res.json();
			setTyoMaara(response.tyomaara)
			setMaaraLoading(false)
		}
	}

	const getOptions = async () => {
		const requestOptions = {
			method: 'GET',
			headers: { 'Content-Type': 'application/json' }
		};

		const res = await fetch("/api/options", requestOptions);

		if (res.ok) {
			const response = await res.json();
			setKohderyhmatOptions(response.kohderyhmatOptions)
			setProsessitOptions(response.prosessitOptions)
			setTyypitOptions(response.tyypitOptions)
			setTieteenalatOptions(response.tieteenalatOptions)
			setTeematOptions(response.teematOptions)
			setKieletOptions(response.kieletOptions)
			setOrganisaatiotOptions(response.organisaatiotOptions)
		}
  }

	const handleGetTyot = () => {
		setPage(1)
		getTyot()
	}

  return (
		<Paper elevation={5} sx={{margin: '2%', padding:'2%', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
			<Grid item container justify="center" spacing={4}>
				<Grid item container xs={12} justify="center" spacing={1}>
					<Grid item xs={3} align="center" sx={{ display: { xs: 'none', lg: 'block' }}}>
						<IconButton disableRipple={true} target="_blank" href="https://palloliitto.fi" rel="noopener noreferrer">
							<Avatar alt="palloliitto" variant="rounded" sx={{ width: { lg: 200 }, height: { lg: 180 }}} src="palloliitto_logo.png" />
						</IconButton>
					</Grid>
					<Grid item lg={6} sx={{ md: 12}} align="center">
						<Typography color="primary" sx={{fontSize: { lg: 50, md: 40, sm: 30, xs: 20} }} variant="h4" style={{fontWeight: '800'}}>Suomalaisen jalkapallon ja futsalin tutkimustietokanta</Typography>
					</Grid>
					<Grid item xs={3} align="center" sx={{ display: { xs: 'none', lg: 'block' }}}>
						<IconButton disableRipple={true} target="_blank" href="https://jyu.fi" rel="noopener noreferrer">
							<Avatar alt="jyu" variant="square" sx={{ width: { lg: 225 }, height: { lg: 145 }, }} src="jyu_logo.jpg" />
						</IconButton>
					</Grid>
				</Grid>
				<Grid item xs={6} sm={6} md={4} lg={3} align="center" >
					<TextField sx={{width: {xs: 120, sm: 250}}} InputProps={{sx: {fontSize: {xs: 12, sm:16}}}} InputLabelProps={{sx: {fontSize: {xs: 12, sm:16}}}} variant="standard" label="Tekijä (etu- tai sukunimi)" value={tekija} onChange={(event) => {setTekija(event.target.value)}} />
				</Grid>
				<Grid item xs={6} sm={6} md={4} lg={3} align="center" >
					<TextField sx={{fontSize: {xs: '12px', sm: '15px'}, width: {xs: 120, sm: 250}}} InputProps={{sx: {fontSize: {xs: 12, sm:16}}}} InputLabelProps={{sx: {fontSize: {xs: 12, sm:16}}}} variant="standard" label="Otsikko" value={otsikko} onChange={(event) => {setOtsikko(event.target.value)}} />
				</Grid>
				<Grid item xs={6} sm={6} md={4} lg={3} align="center">
					<TextField sx={{fontSize: {xs: '12px', sm: '15px'}, width: {xs: 120, sm: 250}}} InputProps={{sx: {fontSize: {xs: 12, sm:16}}}} InputLabelProps={{sx: {fontSize: {xs: 12, sm:16}}}} variant="standard" label="Julkaisuvuosi (Min)" type="number" value={julkaisuvuosiMin} onChange={(event) => {setJulkaisuvuosiMin(event.target.value)}} />
				</Grid>
				<Grid item xs={6} sm={6} md={4} lg={3} align="center" >
					<TextField sx={{fontSize: {xs: '12px', sm: '15px'}, width: {xs: 120, sm: 250}}} InputProps={{sx: {fontSize: {xs: 12, sm:16}}}} InputLabelProps={{sx: {fontSize: {xs: 12, sm:16}}}} variant="standard" label="Julkaisuvuosi (Max)" type="number" value={julkaisuvuosiMax} onChange={(event) => {setJulkaisuvuosiMax(event.target.value)}} />
				</Grid>
				<Grid item xs={12} sm={6} md={4} lg={3} align="center" sx={{ display: { xs: 'none', sm: 'block' }}} >
					<MultiSelect display={{ xs: "none" }}  name="Prosessi" items={prosessitOptions} selectedItems={prosessit} setSelectedItems={setProsessit} />
				</Grid>
				<Grid item xs={6} sm={6} md={4} lg={3} align="center" >
					<MultiSelect name="Kohderyhmä" items={kohderyhmatOptions} selectedItems={kohderyhmat} setSelectedItems={setKohderyhmat} />
				</Grid>
				<Grid item xs={12} sm={6} md={4} lg={3} align="center" sx={{ display: { xs: 'none', sm: 'block' }}} >
					<MultiSelect display={{ xs: "none" }} name="Teema" items={teematOptions} selectedItems={teemat} setSelectedItems={setTeemat} />
				</Grid>
				<Grid item xs={12} sm={6} md={4} lg={3} align="center" sx={{ display: { xs: 'none', sm: 'block' }}} >
					<MultiSelect display={{ xs: "none" }} name="Oppiaine" items={tieteenalatOptions} selectedItems={tieteenalat} setSelectedItems={setTieteenalat} />
				</Grid>
				<Grid item xs={6} sm={6} md={4} lg={3} align="center" >
					<MultiSelect display={{ xs: "none" }} name="Tyyppi" items={tyypitOptions} selectedItems={tyypit} setSelectedItems={setTyypit} />
				</Grid>
				<Grid item xs={6} sm={6} md={4} lg={3} align="center" >
					<MultiSelect name="Kieli" items={kieletOptions} selectedItems={kielet} setSelectedItems={setKielet} />
				</Grid>
				<Grid item xs={6} sm={6} md={4} lg={3} align="center" >
					<MultiSelect name="Saatavuus" items={[{'value': 'saatavilla'}, {'value': 'rajattu saatavuus'}]} selectedItems={saatavuus} setSelectedItems={setSaatavuus} />
				</Grid>
				<Grid item xs={12} sm={6} md={4} lg={3} align="center" sx={{ display: { xs: 'none', sm: 'block' }}} >
					<MultiSelect display={{ xs: "none" }} name="Julkaisija" items={organisaatiotOptions} selectedItems={organisaatiot} setSelectedItems={setOrganisaatiot} />
				</Grid>
				<Grid item xs={0} sm={0} md={4} lg={4.5} align="right" sx={{ display: { xs: 'none', sm: 'none', md: 'block' }}} >
					<FormControl align="center" style={{minWidth: 150, marginRight: 50}}>
							<InputLabel id="tyot-per-sivu-label" style={{backgroundColor:'white', paddingRight:'5px'}}>Tuloksia per sivu</InputLabel>
							<Select
								style={{maxWidth: 150}}
								variant='standard'
								onClose={() => {setTimeout(() => { document.activeElement.blur();}, 0);}}
								labelId="tyot-per-sivu-label"
								id="tyot-per-sivu"
								value={tyotPerSivu}
								onChange={(e) => setTyotPerSivu(e.target.value)}
							>
								<MenuItem value={10}>10</MenuItem>
								<MenuItem value={20}>20</MenuItem>
								<MenuItem value={50}>50</MenuItem>
								<MenuItem value={100}>100</MenuItem>
							</Select>
						</FormControl>
					</Grid>
					<Grid item xs={12} md={4} lg={3} align="center" >
						<Button sx={{minWidth: '250px', minHeight: '60px', borderRadius: 40, fontSize: {xs: '12px', sm: '15px'}}} variant="contained" color="primary" onClick={() => {handleGetTyot()}} >
							{ maaraLoading === true ? <CircularProgress style={{'color': 'white'}} /> : <>HAE {tyoMaara} TYÖTÄ</> }
						</Button>
					</Grid>
					<Grid item xs={0} sm={0} md={4} lg={4.5} align="left" sx={{ display: { xs: 'none', sm: 'none', md: 'block' }}} >
						<FormControl align="center" style={{minWidth: 200, marginLeft: 50}}>
							<InputLabel id="jarjesta-label" style={{backgroundColor:'white', paddingRight:'5px'}}>Järjestä</InputLabel>
							<Select
								style={{maxWidth: 200}}
								variant='standard'
								onClose={() => {setTimeout(() => { document.activeElement.blur();}, 0);}}
								labelId="jarjesta-label"
								id="jarjesta"
								value={jarjesta}
								onChange={(e) => setJarjesta(e.target.value)}
							>
								<MenuItem value={'vuosi DESC'}>Uusin ensin</MenuItem>
								<MenuItem value={'vuosi ASC'}>Vanhin ensin</MenuItem>
								<MenuItem value={'otsikko ASC'}>Otsikon mukaan</MenuItem>
								<MenuItem value={'tekijat ASC'}>Tekijän mukaan</MenuItem>
								<MenuItem value={'tyyppi ASC'}>Työn tyypin mukaan</MenuItem>
								<MenuItem value={'teemat ASC'}>Teeman mukaan</MenuItem>
								<MenuItem value={'kohderyhmat ASC'}>Kohderyhmän mukaan</MenuItem>
								<MenuItem value={'tieteenala ASC'}>Oppiaineen mukaan</MenuItem>
								<MenuItem value={'organisaatio ASC'}>Julkaisijan mukaan</MenuItem>
							</Select>
						</FormControl>
						</Grid>
				<Grid item align="center" xs={12}>
					<ItemHeader />
					<ItemList tyot={tyot} loading={loading} />
				</Grid>
			</Grid>
			<Pagination sx={{marginTop: '2%', marginBottom: '2%', display: {xs: 'none', sm: 'block'}}} size='large' color='primary' count={Math.ceil(tyoMaara / tyotPerSivu)} page={page} onChange={(event, value) => {setPage(value)}} />
			<Pagination sx={{marginTop: '6%', marginBottom: '6%', display: {xs: 'block', sm: 'none'}}} size='small' color='primary' count={Math.ceil(tyoMaara / tyotPerSivu)} page={page} onChange={(event, value) => {setPage(value)}} />
			<Link sx={{fontSize: {xs: '11px', sm: '16px'}}} variant="text" color="primary" href="https://link.webropolsurveys.com/S/FFDB9AB71E22232D" rel="noreferrer" target="_blank">
                Julkaisujen lisäyspyynnöt ja palaute / Begäran om tillägg av publikationer och feedback / Requests for adding publications and feedback
			</Link>
		</Paper>
  );
}